import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Loader from '../components/loader';
import { isEmpty } from '../utils/generic';
import { userMeRequestAction } from '../store/actions/authActions';
import PrivateRoutes from './Private';
import PublicRoutes from './Public';

function Routes() {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const { currentUser, loginLoading } = auth;

  if (loginLoading) {
    return <Loader />;
  } else if (!isEmpty(currentUser)) {
    return <PrivateRoutes auth={auth} />;
  } else {
    const token = localStorage.getItem('token');
    if (isEmpty(token)) {
      return <PublicRoutes />;
    } else {
      dispatch(userMeRequestAction(token));
      return null;
    }
  }
}
export default Routes;
